/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Nov 08 2024
 **/

/**
 * It is a variable that stores the current 3D spatial information I am connected to.
 */
export type MyCurrentSpace = {
	myCurrentSpace: Partial<{
		currentSpace: SwaggerModels.UserSpaceResponseVO;
		currentConference: SwaggerModels.CurrentConferenceResponseVO;
	}>;
};

export type UnityStates = { unity: Partial<MyCurrentSpace> };

export interface UnityDispatch {
	get_my_current_space(): MyCurrentSpace["myCurrentSpace"]["currentSpace" | "currentConference"] | undefined;
	set_my_current_space(
		payload: MyCurrentSpace["myCurrentSpace"]["currentSpace" | "currentConference"] | undefined
	): void;
}
export const InitialUnityStates: UnityStates = {
	unity: {
		myCurrentSpace: undefined
	}
};
